export const Kuwait_State_List = [
    {
        "label": "Al Asimah (Capital)",
        "value": "Al Asimah",
        "stateID": 1
    },
    {
        "label": "Hawalli",
        "value": "Hawalli",
        "stateID": 2
    },
    {
        "label": "Farwaniya",
        "value": "Farwaniya",
        "stateID": 3
    },
    {
        "label": "Ahmadi",
        "value": "Ahmadi",
        "stateID": 4
    },
    {
        "label": "Jahra",
        "value": "Jahra",
        "stateID": 5
    },
    {
        "label": "Mubarak Al-Kabeer",
        "value": "Mubarak Al-Kabeer",
        "stateID": 6
    }
];

export const Kuwait_City_List = [
    {
        label: "Kuwait City",
        value: "Kuwait City",
        stateID: 1 // Al Asimah
    },
    {
        label: "Sharq",
        value: "Sharq",
        stateID: 1
    },
    {
        label: "Salmiya",
        value: "Salmiya",
        stateID: 2 // Hawalli
    },
    {
        label: "Hawalli",
        value: "Hawalli",
        stateID: 2
    },
    {
        label: "Farwaniya",
        value: "Farwaniya",
        stateID: 3 // Farwaniya
    },
    {
        label: "Khaitan",
        value: "Khaitan",
        stateID: 3
    },
    {
        label: "Fahaheel",
        value: "Fahaheel",
        stateID: 4 // Ahmadi
    },
    {
        label: "Mangaf",
        value: "Mangaf",
        stateID: 4
    },
    {
        label: "Jahra",
        value: "Jahra",
        stateID: 5 // Jahra
    },
    {
        label: "Al Naseem",
        value: "Al Naseem",
        stateID: 5
    },
    {
        label: "Abu Al Hasaniya",
        value: "Abu Al Hasaniya",
        stateID: 6 // Mubarak Al-Kabeer
    },
    {
        label: "Al-Qurain",
        value: "Al-Qurain",
        stateID: 6
    }
];

